import React from "react";
import { RelatedPostItemLoaderProps } from "@/types/modules/post/contentComponents";
import usePostByIdProvider from "@/core/dataProviders/providers/posts/usePostByIdProvider";
import hasValidData from "@/core/utils/hasValidData";
import { RelatedPostItem } from "@/components/modules/Post/RelatedPostItem";

export const RelatedPostItemLoader: React.FC<RelatedPostItemLoaderProps> = ({ postId }) => {
  const [post, postReqState] = usePostByIdProvider({ id: postId.toString() });

  return <>{hasValidData(post, postReqState) && <RelatedPostItem post={post} isRelatedInArticle />}</>;
};
